import {
  AsyncPropSelector,
  AppContext,
  StatusTag,
  BackgroundIcon,
  CLIENT_VIEWS,
  SuperPop,
  getTranslatedText
} from '@nile/components';
import { convertMinutesToHours } from '@nile/mangifera/src/Utils/helpers';
import { DisabledTag } from '@nile/mangifera/src/Pebbles/TicketContainer';
import { Popover } from '@superops/ui-design-system';
import { Edit } from '@styled-icons/material/Edit';
import envConfig from '@nile/home/src/Config/env';
import React, { useCallback, useState, useContext } from 'react';
import styled from 'styled-components';
import { FormattedMessage, injectIntl } from 'react-intl';

function ProductHourCell(props) {
  const { cell, intl } = props;
  const allProps = cell.column;
  const rowData = cell?.row?.original || {};
  const { view } = allProps;

  return (
    <div className="flex center">
      <div className="ellipsis flex col center jcenter">
        <div className="flex center self-start">
          {rowData?.serviceItem?.quantityType !== 'UNITS' ? (
            <div className="ml8">
              {' '}
              {convertMinutesToHours(Number(rowData?.qty || 0))}
            </div>
          ) : (
            <div className="ml8">{rowData?.qty}</div>
          )}
        </div>
      </div>
    </div>
  );
}

export default injectIntl(ProductHourCell);
